import useSingleRemoteConfig from "@app/hooks/useSingleRemoteConfig";
import ROUTE from "@app/navigationApp/routes";
import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader";
import { themeColorSet, ThemedPressable, ThemedText, ThemedView } from "@app/theme"
import { FAQ_ICON } from "@app/utils/utils";
import InterestRateIconFaqRevamp from "../../../assets/Icons/InterestRateIconFaqRevamp";
import RepayIcon from "../../../assets/Icons/RepayIcon";
import CashWithdrawalIcon from "../../../assets/Icons/CashWithdrawlIcon";
import CollateralSecuritiesRevampIcon from "../../../assets/Icons/CollateralsSecuritiesRevampicon";
import RenewalIconRevamp from "../../../assets/Icons/RenewalIconRevamp";
import HelpAndSupportRevampIcon from "../../../assets/Icons/HelpAndSupportRevampIcon";
import { ActivityIndicator, FlatList, ScrollView } from "react-native";
import { CaretRight } from "../../sharedComponents/Icons/index";

const calIcon = (icon: string) => {
    switch(icon) {
        case FAQ_ICON.INTEREST_RATE_ICON_FAQ:
            return <InterestRateIconFaqRevamp />
        case FAQ_ICON.REPAY_ICON:
            return <RepayIcon />
        case FAQ_ICON.CASH_WITHDRAWAL:
            return <CashWithdrawalIcon />
        case FAQ_ICON.COLLATERAL_SECURITIES:
            return <CollateralSecuritiesRevampIcon />
        case FAQ_ICON.RENEWAL_ICON:
            return <RenewalIconRevamp />
        case FAQ_ICON.HELP_AND_SUPPORT:
            return <HelpAndSupportRevampIcon />
        default:
            return null
    }
}




const HelpAndSupportRevamp = ({navigation,route}: {navigation: any; route: any}) => {
    const {userName} = route?.params;
    const {configValue , loading : faqLoading} = useSingleRemoteConfig('faqData')
    const faqData = configValue ? JSON.parse(configValue) : []

    const renderItem = ({item,index,navigation}: {item: any; index: number; navigation: any})  => {
        return (
            <ThemedPressable 
                eventName="HELP_AND_SUPPORT_CATEGORY_SELECTED"
                eventProperty={{ category : item?.title}}
                onPress={() => navigation.navigate(ROUTE.FAQ_SCREEN_REVAMP, { item : item?.cards,title : item?.title })}
                style={{marginTop:12,padding:8,borderWidth:1,borderRadius:8,backgroundColor:'white',flexDirection:'row',justifyContent:'space-between',alignItems:'center',borderColor:'#E4E7EC'}}>
                <ThemedView style={{flexDirection:'row',alignItems:'center'}}>
                    {calIcon(item?.icon)}
                    <ThemedView style={{marginLeft:8}}>
                        <ThemedText 
                            variant="b3m"
                            color="text-primary"
                        >
                            {item?.title}
                        </ThemedText>
                        <ThemedView style={{marginTop:4}}>
                            <ThemedText 
                                variant="b5r"
                                color="text-secondary"
                            >
                                {item?.subtitle}
                            </ThemedText>
                        </ThemedView>
                    </ThemedView>
                </ThemedView>
                {<CaretRight size={16} />}
            </ThemedPressable>
        )
    }

    return (
    <>
        <PageHeaders label="Help and support" pageName="FAQ_SCREEN_REVAMP" navigation={navigation}/>
        <ScrollView style={{backgroundColor:themeColorSet["bg-surface-page"] , flex:1}}>    
            <ThemedView px="lg" pb="lg">
                <ThemedText variant="h3s" mt="2xl" color="text-action-primary">
                    Hi {userName},
                </ThemedText>
                <ThemedText variant="b2r" mt="xs" color="text-primary">
                    How can we help you today?
                </ThemedText>
                {faqLoading && !configValue ? 
                    (
                        <ThemedView justifyContent='center' alignItems='center' minHeight={400} flex={1}>
                            <ActivityIndicator />
                        </ThemedView>
                    ) :
                    (
                    <ThemedView mt="md">
                        <FlatList
                            data={faqData?.faqData}
                            renderItem={({item, index}) => renderItem({item, index, navigation})}
                            keyExtractor={(item) => item.id}
                        />
                    </ThemedView>)
                }
            </ThemedView>
        </ScrollView>
    </>
    )
}   

export default HelpAndSupportRevamp;